
/* ================= DATE FORMATTER  ================= */

function formatDate(dateStr) {
  const d = new Date(dateStr);
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
  });
}

function formatDateTime(dateStr) {
  const d = new Date(dateStr);

  return d.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}


function getPageNumbers(current, total) {
  const pages = [];

  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  pages.push(1);

  if (current > 3) {
    pages.push("...");
  }

  for (let i = current - 1; i <= current + 1; i++) {
    if (i > 1 && i < total) {
      pages.push(i);
    }
  }

  if (current < total - 2) {
    pages.push("...");
  }

  pages.push(total);

  return pages;
}

const transformData = (hit) => {
  const d = hit._source;

  return {
    employee: {
      name: d.EMPLOYEE_NAME,
      code: d.EMPLOYEE_CODE,
      role: d.ROLE,
      city: d.CITY,
      state: d.STATE,
      designation: d.DESIGNATION,
    },
    metrics: {
      achievement: d.ACHIEVEMENT_BUSINESS,
      totalCount: d.TOTAL_COUNT,
      wirr: d.WIRR_PERC,
    },
    incentives: {
      finalPayout: d.FINAL_PAYOUT,
      productIncentive: d.FINAL_PRODUCT_INCENTIVE,
    },
    grids: d.applicableGrids || [],
    decisionOutputs: d.decisionOutputs || [],
  };
};

const transformGrids = (source) => {
  const grids = source.applicableGrids || [];
  const outputs = source.decisionOutputs || [];

  return grids.map((grid, index) => ({
    gridName: grid.grid,
    formula: safeParse(grid.formula),
    rawFormula: grid.formula,
    outputColumns: grid.outputGridReportingColumn,
    outputJsonColumn: grid.outputJSONFormulaReportingColumn,
    outputs: outputs[index] || []
  }));
};

const safeParse = (formula) => {
  try {
    return JSON.parse(formula);
  } catch {
    return null;
  }
};

const formatFormula = (node) => {
  if (!node) return "";

  if (node.var) return node.var;

  if (node.min) {
    return `min(${node.min.map(formatFormula).join(", ")})`;
  }

  if (node["*"]) {
    return `(${node["*"].map(formatFormula).join(" * ")})`;
  }

  if (node["/"]) {
    return `(${node["/"].map(formatFormula).join(" / ")})`;
  }

  return JSON.stringify(node);
};


const getOperatorLabel = (op) => {
  switch (op) {
    case "*": return "×";
    case "/": return "÷";
    case "+": return "+";
    case "-": return "-";
    case "min": return "min";
    default: return op;
  }
};

/* =========================================================
   PERIOD NAME HELPERS
   ========================================================= */

const getWeekNumber = (date) => {
  const currentDate = new Date(date);

  currentDate.setHours(0, 0, 0, 0);

  currentDate.setDate(
    currentDate.getDate() +
      3 -
      ((currentDate.getDay() + 6) % 7)
  );

  const week1 = new Date(
    currentDate.getFullYear(),
    0,
    4
  );

  return (
    1 +
    Math.round(
      ((currentDate - week1) / 86400000 -
        3 +
        ((week1.getDay() + 6) % 7)) /
        7
    )
  );
};

const formatPeriodName = (
  frequencyType,
  frequencyValue
) => {
  if (!frequencyType || !frequencyValue) {
    return "";
  }

  try {
    const [startValue, endValue] =
      frequencyValue.split(" - ");

    const startDate = new Date(
      startValue?.replace(" ", "T")
    );

    const endDate = new Date(
      (endValue || startValue)?.replace(" ", "T")
    );

    if (Number.isNaN(startDate.getTime())) {
      return "";
    }

    const type = frequencyType.toLowerCase();

    const monthName = startDate
      .toLocaleString("en-US", {
        month: "long",
      })
      .toUpperCase();

    const year = startDate.getFullYear();

    const day = String(
      startDate.getDate()
    ).padStart(2, "0");

    switch (type) {
      case "month":
      case "monthly":
        return `${monthName}_${year}`;

      case "week":
      case "weekly": {
        const weekNumber = String(
          getWeekNumber(startDate)
        ).padStart(2, "0");

        return `WEEK_${weekNumber}_${year}`;
      }

      case "day":
      case "daily":
        return `${monthName}_${day}_${year}`;

      case "quarter":
      case "quarterly": {
        const quarter =
          Math.floor(
            startDate.getMonth() / 3
          ) + 1;

        return `Q${quarter}_${year}`;
      }

      default:
        return `${monthName}_${year}`;
    }
  } catch (error) {
    console.error(
      "Error generating period name:",
      error
    );

    return "";
  }
};

/* =========================================================
   CALCULATION COLUMN GROUP EXTRACTION
   ========================================================= */

const extractColumnGroups = (data) => {
    const paymentPartyColumns = new Set();
    const inputColumns = new Set();
    const outputColumns = new Set();

    const normalize = (value) => value
        ?.toString()
            .trim()
            .toLowerCase();

    const addInputKeys = (obj) => {
        if (!obj || typeof obj !== "object") {
            return;
        }

        Object
            .keys(obj)
            .forEach((key) => {
                if (key
                    ?.trim()) {
                    inputColumns.add(normalize(key));
                }
            });
    };

    /* =========================================================
     PAYMENT PARTY

     Example:

     Agency

     OR

     Agency:_:Agent_Code:_:Account_No
     ========================================================= */

    if (data
        ?.composite_key_order) {
        data
            .composite_key_order
            .toString()
            .split(":_:")
            .map((value) => value.trim())
            .filter(Boolean)
            .forEach((value) => {
                paymentPartyColumns.add(normalize(value));
            });
    }

    /* =========================================================
     DECISION OUTPUTS
     ========================================================= */

    const decisionOutputs = Array.isArray(data
        ?.decisionOutputs)
        ? data.decisionOutputs
        : [];

    decisionOutputs.forEach((decision) => {
        /* -----------------------------------------
         decisionInputs -> INPUT
         ----------------------------------------- */

        if (Array.isArray(decision
            ?.decisionInputs)) {
            decision
                .decisionInputs
                .forEach((inputObject) => {
                    addInputKeys(inputObject);
                });
        }

        /* -----------------------------------------
         output_formula.inputs -> INPUT
         ----------------------------------------- */

        if (Array.isArray(decision
            ?.output_formula
                ?.inputs)) {
            decision
                .output_formula
                .inputs
                .forEach((inputObject) => {
                    addInputKeys(inputObject);
                });
        }

        /* -----------------------------------------
         decisionOutputVariables -> OUTPUT
         ----------------------------------------- */

        if (Array.isArray(decision
            ?.decisionOutputVariables)) {
            decision
                .decisionOutputVariables
                .forEach((output) => {
                    if (output
                        ?.outputName
                            ?.trim()) {
                        outputColumns.add(normalize(output.outputName));
                    }
                });
        }
    });

    /* =========================================================
     FINAL OUTPUT FORMULA INPUTS -> INPUT
     ========================================================= */

    if (Array.isArray(data
        ?.final_output_formula
            ?.inputs)) {
        data
            .final_output_formula
            .inputs
            .forEach((inputObject) => {
                addInputKeys(inputObject);
            });
    }

    /* =========================================================
     FINAL OUTPUT -> OUTPUT
     ========================================================= */

    const finalOutputColumn = normalize(data
        ?.final_output_variable_name);

    if (finalOutputColumn) {
        outputColumns.add(finalOutputColumn);
    }

    return {paymentPartyColumns, inputColumns, outputColumns, finalOutputColumn};
};

/**
 * 
 * @param {*} apiDataType 
 * @returns 
 */
const getMappingDataType = (apiDataType) => {
  if (!apiDataType) return "String";

  const type = String(apiDataType).trim().toLowerCase();

  switch (type) {
    case "string":
    case "text":
    case "varchar":
    case "char":
      return "String";

    case "decimal":
    case "number":
    case "numeric":
    case "float":
    case "double":
    case "int":
    case "integer":
    case "bigint":
      return "Number";

    case "date":
    case "datetime":
    case "timestamp":
      return "Date";

    default:
      return "String";
  }
};

export{
    formatDate,
    formatDateTime,
    getPageNumbers,
    transformData,
    transformGrids,
    formatFormula,
    getOperatorLabel,
    formatPeriodName,
    getWeekNumber,
    extractColumnGroups,
    getMappingDataType
}